import { MdDownload, MdFavorite, MdMessage, MdPerson, MdVisibility } from 'react-icons/md';

interface TotalsProps {
  totalUsersLoggedIn: number;
  totalViews: number;
  totalFavorites: number;
  totalComments: number;
  totalDownloads: number;
}

interface StatCardProps {
  label: string;
  value: number;
  icon: React.ReactNode;
}

const StatCard: React.FC<StatCardProps> = ({ label, value, icon }) => (
  <div className="flex flex-col items-center justify-between bg-white p-4 gap-2 rounded-md shadow-md min-h-[90px] flex-1 min-w-[140px]">
    <div className="flex items-center gap-1 text-gray-500">
      {icon}
      <span className="text-xs">{label}</span>
    </div>
    <span className="text-3xl font-bold">{value.toLocaleString('es-CO')}</span>
  </div>
);

const Totals: React.FC<TotalsProps> = ({
  totalUsersLoggedIn,
  totalViews,
  totalFavorites,
  totalComments,
  totalDownloads,
}) => {
  return (
    <div className="flex flex-col gap-2">
      <span className="text-sm text-gray-500">Totales generales</span>
      <div className="flex flex-wrap items-center gap-2">
        <StatCard label="Usuarios que han ingresado" value={totalUsersLoggedIn} icon={<MdPerson size={14} />} />
        <StatCard label="Visualizaciones" value={totalViews} icon={<MdVisibility size={14} />} />
        <StatCard label="Favoritos" value={totalFavorites} icon={<MdFavorite size={14} />} />
        <StatCard label="Comentarios" value={totalComments} icon={<MdMessage size={14} />} />
        <StatCard label="Descargas" value={totalDownloads} icon={<MdDownload size={14} />} />
      </div>
    </div>
  );
};

export default Totals;
